import { CompanyEntity } from '../common/entity';
import { OrderFlowAction } from './orderFlowAction';
import { OrderFlowPermission } from './orderFlowPermissions';
import { ProductTransactionFlowAction } from './productTransactionFlowAction';

export enum FlowType {
  inbound = 'inbound',
  move = 'move',
  outbound = 'outbound',

  // Should these still exists???
  replenish = 'replenish',
  disposal = 'disposal',
}

export class OrderFlow extends CompanyEntity {
  type!: FlowType;

  name!: string;
  description?: string;
  enabled: boolean = true;

  fromPermissions: OrderFlowPermission = new OrderFlowPermission();
  toPermissions: OrderFlowPermission = new OrderFlowPermission();

  orderActions: OrderFlowAction[] = [];
  productTransactionActions: ProductTransactionFlowAction[] = [];

  customFieldIds: string[] = [];

  orderFormat: string = '${NUMBER}';

  constructor(obj: any) {
    if (!obj.companyId) return;
    super(obj.companyId);
    Object.assign(this, obj);
  }
}
